import React, { useState, useEffect } from 'react';
import Navbar from '../layout/Navbar';
import Footer from '../layout/Fotter';
import gvttilsroom from '../../assets/floor.image.jpg';
import Carving from '../../assets/FloorImages/CARVING.jpg';
import Carving1 from '../../assets/FloorImages/CARVING1.jpg';
import Carving2 from '../../assets/FloorImages/CARVING2.jpg';
import Carving3 from '../../assets/FloorImages/CARVING3.jpg';
import Carving4 from '../../assets/FloorImages/CARVING4.jpg';
import Carving5 from '../../assets/FloorImages/CARVING5.jpg';
import Carving6 from '../../assets/FloorImages/CARVING6.jpg';
import Carving7 from '../../assets/FloorImages/CARVING7.jpg';
import AbachiBeige from '../../assets/FloorImages/Abachi Beige.jpg';
// import AdanaAsh from '../../assets/FloorImages/Adana Ash.jpg';
import matt1 from '../../assets/floormatt/matt1.jpg';
import matt2 from '../../assets/floormatt/matt2.jpg';
import matt3 from '../../assets/floormatt/matt3.jpg';
import matt4 from '../../assets/floormatt/matt4.jpg';
import matt5 from '../../assets/floormatt/matt5.jpg';
import matt6 from '../../assets/floormatt/matt6.jpg';
import matt7 from '../../assets/floormatt/matt7.jpg';
import matt8 from '../../assets/floormatt/matt8.jpg';
import glossy1 from '../../assets/600x1200/glossy1.jpg';
import glossy2 from '../../assets/600x1200/glossy2.jpg';
import glossy3 from '../../assets/600x1200/glossy3.jpg';
import glossy4 from '../../assets/600x1200/glossy4.jpg';
import glossy5 from '../../assets/600x1200/glossy5.jpg';
import glossy6 from '../../assets/600x1200/glossy6.jpg';
import glossy7 from '../../assets/600x1200/glossy7.jpg';
import glossy8 from '../../assets/600x1200/glossy8.jpg';
import goldenCarving from '../../assets/600x1200/goldenCarving/goldenCarving.avif';
import goldenCarving1 from '../../assets/600x1200/goldenCarving/goldenCarvingImages.jpg';
import goldenCarving2 from '../../assets/600x1200/goldenCarving/goldenCarvingImages1.jpg';
import goldenCarving3 from '../../assets/600x1200/goldenCarving/goldenCarvingImages3.avif';
import goldenCarving4 from '../../assets/600x1200/goldenCarving/goldenCarvingImages4.avif';
import goldenCarving5 from '../../assets/600x1200/goldenCarving/goldenCarvingImages5.jpg';
import ghr from '../../assets/600x1200/ghr/ghr.avif';
import ghr1 from '../../assets/600x1200/ghr/ghr1.avif';
import ghr2 from '../../assets/600x1200/ghr/ghr2.avif';
import ghr3 from '../../assets/600x1200/ghr/ghr3.avif';
import ghr4 from '../../assets/600x1200/ghr/ghr4.webp';
import ghr5 from '../../assets/600x1200/ghr/ghr5.avif';
import ghr6 from '../../assets/600x1200/ghr/ghr6.png';
import velvet from '../../assets/600x1200/velvet/velvet.jpg';
import velvet1 from '../../assets/600x1200/velvet/velvet1.jpg';
import velvet2 from '../../assets/600x1200/velvet/velvet2.jpg';
import velvet3 from '../../assets/600x1200/velvet/velvet3.jpg';
import velvet4 from '../../assets/600x1200/velvet/velvet4.jpg';
import velvet5 from '../../assets/600x1200/velvet/velvet5.jpg';
import velvet6 from '../../assets/600x1200/velvet/velvet6.jpg';
import velvet7 from '../../assets/600x1200/velvet/velvet7.jpg';
import rokar from '../../assets/600x1200/rokar/rokar.jpg';
import rokar1 from '../../assets/600x1200/rokar/rokar1.jpg';
import rokar2 from '../../assets/600x1200/rokar/rokar2.jpg';
import rokar3 from '../../assets/600x1200/rokar/rokar3.jpg';
import rokar4 from '../../assets/600x1200/rokar/rokar4.jpg';
import rokar5 from '../../assets/600x1200/rokar/rokar5.jpg';
import rokar6 from '../../assets/600x1200/rokar/rokar6.jpg';
import rokar7 from '../../assets/600x1200/rokar/rokar7.jpg';
import inkyPinky from '../../assets/600x1200/inky_pinky/inkyPinky.jpg';
import inkyPinky1 from '../../assets/600x1200/inky_pinky/inkyPinky1.jpg';
import inkyPinky2 from '../../assets/600x1200/inky_pinky/inkyPinky2.jpg';
import inkyPinky3 from '../../assets/600x1200/inky_pinky/inkyPinky3.jpg';
import inkyPinky4 from '../../assets/600x1200/inky_pinky/inkyPinky4.jpg';
import inkyPinky5 from '../../assets/600x1200/inky_pinky/inkyPinky5.jpg';
import inkyPinky6 from '../../assets/600x1200/inky_pinky/inkyPinky6.jpg';
import inkyPinky7 from '../../assets/600x1200/inky_pinky/inkyPinky7.jpg';
import floormain1 from '../../assets/FloorImages/floormain1.jpg';
import floormain2 from '../../assets/FloorImages/floormain2.jpg';
import floormain3 from '../../assets/FloorImages/floormain3.jpg';
import floormain4 from '../../assets/FloorImages/floormain4.jpg';
import floormain5 from '../../assets/FloorImages/floormain5.jpg';
import floormain6 from '../../assets/FloorImages/floormain6.avif';
import floormain7 from '../../assets/FloorImages/floormain7.jpg';
import floormain8 from '../../assets/FloorImages/floormain8.jpg';
import carvingmain1 from '../../assets/FloorImages/carvingmain1.jpg';
import carvingmain2 from '../../assets/FloorImages/carvingmain2.jpg';
import carvingmain3 from '../../assets/FloorImages/carvingmain3.jpg';
import carvingmain4 from '../../assets/FloorImages/carvingmain4.jpg';
import carvingmain5 from '../../assets/FloorImages/carvingmain5.jpg';
import carvingmain6 from '../../assets/FloorImages/carvingmain6.jpg';
import mattmain1 from '../../assets/FloorImages/matt1.jpg';
import mattmain2 from '../../assets/FloorImages/matt2.jpg';
import mattmain3 from '../../assets/FloorImages/matt3.jpg';
import mattmain6 from '../../assets/FloorImages/matt6.jpg';
import floorglossy2 from '../../assets/FloorImages/floorglossy2.jpg';
import floorglossy4 from '../../assets/FloorImages/floorglossy4.jpg';
import floorglossy5 from '../../assets/FloorImages/floorglossy5.jpg';
import floorglossy6 from '../../assets/FloorImages/floorglossy6.jpg';
import floorglossy7 from '../../assets/FloorImages/floorglossy7.jpg';


const Gvt = () => {
  // State for modal
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [isImageLoading, setIsImageLoading] = useState(true);

  // State for filters
  const [selectedSize, setSelectedSize] = useState("600 x 1200 mm");
  const [selectedFinish, setSelectedFinish] = useState("GLOSSY");

  // Available Finishes
  const availableFinishes = [
    'CARVING', 'INKY PINKY', 'ROKAR',
    'VELVET', 'GHR', 'GOLDEN CARVING',
    'MATT', 'GLOSSY',
  ];

  // Function to open modal with selected image
  const openModal = (image, title, viewMode = 'single', roomScene = null) => {
    setIsImageLoading(true);
    setSelectedImage({ src: image, title, viewMode, roomScene });
    setIsModalOpen(true);
  };

  // Function to close modal
  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedImage(null);
    setIsImageLoading(true);
  };

  // Handle outside click to close modal
  const handleOutsideClick = (e) => {
    if (e.target === e.currentTarget) {
      closeModal();
    }
  };

  // Handle keyboard accessibility and prevent body scroll
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        closeModal();
      }
    };
    if (isModalOpen) {
      document.body.style.overflow = 'hidden';
      window.addEventListener('keydown', handleKeyDown);
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => {
      document.body.style.overflow = 'auto';
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isModalOpen]);

  // Carving Images Collection
  const carvingImages = [
    { src: Carving, title: 'Abachi Beige', roomScene: carvingmain1 },
    { src: Carving1, title: 'Adana Ash', roomScene: carvingmain2 },
    { src: Carving2, title: 'Adana Brown', roomScene: carvingmain3 },
    { src: Carving3, title: 'Adana Grey', roomScene: carvingmain4 },
    { src: Carving4, title: 'Alabaster Grey' },
    { src: Carving5, title: 'Alabaster Brown' },
    { src: Carving6, title: 'Angora Statuario', roomScene: carvingmain5 },
    { src: Carving7, title: 'Baron Brown', roomScene: carvingmain6 },
  ];

  // Matt Images Collection
  const mattImages = [
    { src: matt1, title: 'ALORA BIANCO', roomScene: mattmain1 },
    { src: matt2, title: 'ALORA BROWN' },
    { src: matt3, title: 'ALORA CREMA', roomScene: mattmain3 },
    { src: matt4, title: 'ALORA DECOR 1' },
    { src: matt5, title: 'ALORA DECOR 2' },
    { src: matt6, title: 'ALORA GRIS', roomScene: mattmain6 },
    { src: matt7, title: 'ALORA BEIGE' },
    { src: matt8, title: 'ALORA BROWN' },
  ];

  // Glossy Images Collection
  const glossyImages = [
    { src: glossy1, title: 'ELITE ONYX' },
    { src: glossy2, title: 'EVOLIC GREY', roomScene: floorglossy2 },
    { src: glossy3, title: 'EVOLIC NATURAL' },
    { src: glossy4, title: 'EX-104 ANTICO BOTTOCHINO GR', roomScene: floorglossy4 },
    { src: glossy5, title: 'EX-105 ANTICO BOTTOCHINO BR', roomScene: floorglossy5 },
    { src: glossy6, title: 'EX-109 ARENA BIANCO', roomScene: floorglossy6 },
    { src: glossy7, title: 'EX-110 ARENA BROWN', roomScene: floorglossy7 },
    { src: glossy8, title: 'EX-113 ARMANI GREY' },
  ];

  const goldenCarvingImages = [
    { src: goldenCarving, title: 'Carving Sofitel Gold Marble', roomScene: floormain1 },
    { src: goldenCarving1, title: 'Carving Endless Gold Spider Marble', roomScene: floormain2 },
    { src: goldenCarving2, title: 'Golden Spider', roomScene: floormain3 },
    { src: goldenCarving3, title: 'Golden Streak Carving', roomScene: floormain4 },
    { src: goldenCarving4, title: 'Carving Breccia Gold Veins Marble', roomScene: floormain5 },
    { src: goldenCarving5, title: 'Golden White', roomScene: floormain6 },
  ];

  const ghrImages = [
    { src: ghr, title: 'Riverstone Platinum GHR Matte', roomScene: floormain7 },
    { src: ghr1, title: 'Rawstone Desert GHR Matte', roomScene: floormain8 },
    { src: ghr2, title: 'Latte Terrazzo GHR Matte', roomScene: floormain1 },
    { src: ghr3, title: 'Camel Limecrest GHR Matte', roomScene: floormain2 },
    { src: ghr4, title: 'Ceramic GHR Surface Tiles', roomScene: floormain3 },
    { src: ghr5, title: 'Ash Limecrest GHR Matte', roomScene: floormain4 },
    { src: ghr6, title: 'GHR FENIX GRIS', roomScene: floormain5 },
  ];

  const velvetImages = [
    { src: velvet, title: 'Botticino Nex', roomScene: floormain6 },
    { src: velvet1, title: 'Lykra Silver', roomScene: floormain7 },
    { src: velvet2, title: 'Travein Silver', roomScene: floormain8 },
    { src: velvet3, title: 'Jasper Beige', roomScene: floormain1 },
    { src: velvet4, title: 'Carley Crema', roomScene: floormain2 },
    { src: velvet5, title: 'Travein Crema', roomScene: floormain3 },
    { src: velvet6, title: 'Carley Grey', roomScene: floormain4 },
    { src: velvet7, title: 'Travein Grey', roomScene: floormain5 },
  ];

  const rokarImages = [
    { src: rokar, title: 'Majestic Dove', roomScene: floormain6 },
    { src: rokar1, title: 'Olbia Sparkle', roomScene: floormain7 },
    { src: rokar2, title: 'Fiama Coffee', roomScene: floormain8 },
    { src: rokar3, title: 'Caravana Decor', roomScene: floormain1 },
    { src: rokar4, title: 'Bellini Crema Decor', roomScene: floormain2 },
    { src: rokar5, title: 'Skyler Decor', roomScene: floormain3 },
    { src: rokar6, title: 'Katly Decor', roomScene: floormain4 },
    { src: rokar7, title: 'Skyler Marfil', roomScene: floormain5 },
  ];

  const inkyPinkyImages = [
    { src: inkyPinky, title: 'ALASCA MULTI STATUARIO', roomScene: floormain1 },
    { src: inkyPinky1, title: 'BRESSICO WHITE', roomScene: floormain2 },
    { src: inkyPinky2, title: 'BRUMOSO WHITE', roomScene: floormain3 },
    { src: inkyPinky3, title: 'CAPTIV AQUA_ENDLESS', roomScene: floormain4 },
    { src: inkyPinky4, title: 'DIORITA GREEN', roomScene: floormain5 },
    { src: inkyPinky5, title: 'JELOS OLIVE', roomScene: floormain6 },
    { src: inkyPinky6, title: 'JELOS TAUPE', roomScene: floormain7 },
    { src: inkyPinky7, title: 'LEO ONYX GREEN', roomScene: floormain8 },
  ];

  const gvtCategory = {
    fullName: "Glazed Vitrified Tiles",
    description:
      "Premium quality glazed vitrified tiles with exceptional durability and water resistance.",
    features: ["Water Absorption < 0.5%", "High Strength", "Stain Resistant", "Easy Maintenance"],
  };

  return (
    <div className="w-full overflow-hidden">
      {/* Navbar */}
      <Navbar />

      {/* Hero Section */}
      <section className="relative h-[50vh] sm:h-[60vh] md:h-[70vh] lg:h-[80vh] bg-gradient-to-r from-gray-900 via-gray-800 to-orange-900">
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${gvttilsroom})` }}
        ></div>
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        <div className="relative z-10 h-full flex items-center justify-center">
          <div className="text-center text-white max-w-full sm:max-w-2xl md:max-w-3xl lg:max-w-4xl px-4 sm:px-6">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-orange-500 mb-4 sm:mb-6 drop-shadow-2xl">
              Floor Collection
            </h1>
            <p className="text-base sm:text-lg md:text-xl lg:text-2xl font-light">
              {gvtCategory.fullName}
            </p>
            <div className="mt-4 sm:mt-6 w-24 sm:w-28 lg:w-32 h-1 bg-orange-500 mx-auto"></div>
          </div>
        </div>
      </section>

      {/* Product Info Section */}
      <section className="py-8 sm:py-12 lg:py-16 bg-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 sm:mb-12 lg:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-3 sm:mb-4">
              Premium <span className="text-orange-600">Floor Tiles</span>
            </h2>
            <p className="text-sm sm:text-base md:text-lg text-gray-600 max-w-2xl sm:max-w-3xl lg:max-w-4xl mx-auto mb-6 sm:mb-8 leading-relaxed">
              {gvtCategory.description} Our Floor tiles combine advanced technology with superior design
              to create surfaces that are not only beautiful but also highly functional and long-lasting.
            </p>
            {/* Features */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 max-w-5xl mx-auto">
              {gvtCategory.features.map((feature, index) => (
                <div
                  key={index}
                  className="bg-gradient-to-br from-orange-50 to-orange-100 p-4 sm:p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300"
                >
                  <div className="bg-orange-600 text-white text-lg sm:text-xl md:text-2xl w-10 h-10 sm:w-12 sm:h-12 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
                    ✓
                  </div>
                  <p className="text-gray-800 font-semibold text-sm sm:text-base md:text-lg">{feature}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* NEW FILTER SECTION */}
      <section className="py-8 bg-gray-50">
        <div className="container mx-auto px-4 sm:px-1">
          <div className="bg-white rounded-[2rem] p-6 sm:p-8 md:p-12 shadow-xl border border-gray-100">
            <div className="flex flex-col lg:flex-row gap-8 lg:gap-16">

              {/* Size Selection */}
              <div className="lg:w-1/3">
                <h3 className="text-gray-800 text-xl sm:text-2xl font-medium mb-6">Choose By Size</h3>
                <div className="flex flex-col gap-4">
                  {["600 x 1200 mm", "600 x 600 mm"].map((size) => (
                    <button
                      key={size}
                      onClick={() => setSelectedSize(selectedSize === size ? null : size)}
                      className={`
                        w-full py-4 px-6 rounded-xl text-lg font-bold transition-all duration-300 border
                        ${selectedSize === size
                          ? 'bg-orange-600 text-white border-orange-600 shadow-lg scale-105'
                          : 'bg-white border-gray-200 text-gray-600 hover:border-orange-200 hover:bg-orange-50'}
                      `}
                    >
                      {size.toUpperCase()}
                    </button>
                  ))}
                </div>
              </div>

              {/* Vertical Divider (Visible on Large Screens) */}
              <div className="hidden lg:block w-px bg-gray-200 my-2"></div>

              {/* Horizontal Divider (Visible on Small Screens) */}
              <div className="block lg:hidden h-px w-full bg-gray-200"></div>

              {/* Finish Selection */}
              <div className="lg:w-2/3">
                <h3 className="text-gray-800 text-xl sm:text-2xl font-medium mb-6">Choose By Finish</h3>
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 sm:gap-4">
                  {availableFinishes
                    .filter(finish => {
                      if (selectedSize === "600 x 600 mm") {
                        return ['CARVING', 'MATT'].includes(finish);
                      } else if (selectedSize === "600 x 1200 mm") {
                        return !['CARVING', 'MATT'].includes(finish);
                      }
                      return true;
                    })
                    .map((finish) => (
                      <button
                        key={finish}
                        onClick={() => setSelectedFinish(selectedFinish === finish ? null : finish)}
                        className={`
                        py-3 px-2 sm:px-4 rounded-xl text-xs sm:text-sm font-bold transition-all duration-300 h-16 sm:h-20 flex items-center justify-center text-center border
                        ${selectedFinish === finish
                            ? 'bg-orange-600 text-white border-orange-600 shadow-lg scale-105'
                            : 'bg-white border-gray-200 text-gray-600 hover:border-orange-200 hover:bg-orange-50'}
                      `}
                      >
                        {finish}
                      </button>
                    ))}
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>

      {/* Carving Collection Grid */}
      {selectedFinish === 'CARVING' && selectedSize === "600 x 600 mm" && (
        <section className="py-8 sm:py-12 bg-white animate-fade-in">
          <div className="container mx-auto px-4 sm:px-6">
            <div className="text-center mb-8">
              <h3 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-2">
                Carving Series <span className="text-orange-600">Collection</span>
              </h3>
              <p className="text-gray-600 max-w-2xl mx-auto">
                Experience the depth and texture of our premium Carving finish tiles.
              </p>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-10">
              {carvingImages.map((img, index) => (
                <div
                  key={index}
                  className="group relative cursor-pointer overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 bg-white"
                  onClick={() => openModal(img.src, img.title, 'detail', img.roomScene)}
                >
                  <div className="aspect-[2/3] overflow-hidden relative">
                    <img
                      src={img.src}
                      alt={img.title}
                      className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-all duration-300"></div>
                  </div>

                  {/* Image Details */}
                  <div className="p-4 text-center">
                    <h4 className="text-gray-800 font-bold text-lg mb-1">{img.title}</h4>
                    <p className="text-gray-500 text-sm mb-1">Size: 600 x 600 mm</p>
                    <span className="inline-block bg-orange-100 text-orange-800 text-xs px-2 py-1 rounded-full font-semibold">
                      Carving Finish
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* Matt Collection Grid */}
      {selectedFinish === 'MATT' && selectedSize === "600 x 600 mm" && (
        <section className="py-8 sm:py-12 bg-white animate-fade-in">
          <div className="container mx-auto px-4 sm:px-6">
            <div className="text-center mb-8">
              <h3 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-2">
                Matt Series <span className="text-orange-600">Collection</span>
              </h3>
              <p className="text-gray-600 max-w-2xl mx-auto">
                Discover the elegant and extensive range of our Matt finish tiles.
              </p>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-10">
              {mattImages.map((img, index) => (
                <div
                  key={index}
                  className="group relative cursor-pointer overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 bg-white"
                  onClick={() => openModal(img.src, img.title, 'detail', img.roomScene)}
                >
                  <div className="aspect-[2/3] overflow-hidden relative">
                    <img
                      src={img.src}
                      alt={img.title}
                      className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-all duration-300"></div>
                  </div>

                  {/* Image Details */}
                  <div className="p-4 text-center">
                    <h4 className="text-gray-800 font-bold text-lg mb-1">{img.title}</h4>
                    <p className="text-gray-500 text-sm mb-1">Size: 600 x 600 mm</p>
                    <span className="inline-block bg-orange-100 text-orange-800 text-xs px-2 py-1 rounded-full font-semibold">
                      Matt Finish
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* Glossy Collection Grid */}
      {selectedFinish === 'GLOSSY' && selectedSize === "600 x 1200 mm" && (
        <section className="py-8 sm:py-12 bg-white animate-fade-in">
          <div className="container mx-auto px-4 sm:px-6">
            <div className="text-center mb-8">
              <h3 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-2">
                Glossy Series <span className="text-orange-600">Collection</span>
              </h3>
              <p className="text-gray-600 max-w-2xl mx-auto">
                Reflect elegance with our premium Glossy finish tiles.
              </p>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-10">
              {glossyImages.map((img, index) => (
                <div
                  key={index}
                  className="group relative cursor-pointer overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 bg-white"
                  onClick={() => openModal(img.src, img.title, 'detail', img.roomScene)}
                >
                  <div className="aspect-[2/3] overflow-hidden relative">
                    <img
                      src={img.src}
                      alt={img.title}
                      className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-all duration-300"></div>
                  </div>

                  {/* Image Details */}
                  <div className="p-4 text-center">
                    <h4 className="text-gray-800 font-bold text-lg mb-1">{img.title}</h4>
                    <p className="text-gray-500 text-sm mb-1">Size: 600 x 1200 mm</p>
                    <span className="inline-block bg-orange-100 text-orange-800 text-xs px-2 py-1 rounded-full font-semibold">
                      Glossy Finish
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* Golden Carving Collection Grid */}
      {selectedFinish === 'GOLDEN CARVING' && selectedSize === "600 x 1200 mm" && (
        <section className="py-8 sm:py-12 bg-white animate-fade-in">
          <div className="container mx-auto px-4 sm:px-6">
            <div className="text-center mb-8">
              <h3 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-2">
                Golden Carving Series <span className="text-orange-600">Collection</span>
              </h3>
              <p className="text-gray-600 max-w-2xl mx-auto">
                Reflect elegance with our premium Golden Carving finish tiles.
              </p>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-10">
              {goldenCarvingImages.map((img, index) => (
                <div
                  key={index}
                  className="group relative cursor-pointer overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 bg-white"
                  onClick={() => openModal(img.src, img.title, 'detail', img.roomScene)}
                >
                  <div className="aspect-[2/3] overflow-hidden relative">
                    <img
                      src={img.src}
                      alt={img.title}
                      className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-all duration-300"></div>
                  </div>

                  {/* Image Details */}
                  <div className="p-4 text-center">
                    <h4 className="text-gray-800 font-bold text-lg mb-1">{img.title}</h4>
                    <p className="text-gray-500 text-sm mb-1">Size: 600 x 1200 mm</p>
                    <span className="inline-block bg-orange-100 text-orange-800 text-xs px-2 py-1 rounded-full font-semibold">
                      Golden Carving Finish
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* ghr */}
      {selectedFinish === 'GHR' && selectedSize === "600 x 1200 mm" && (
        <section className="py-8 sm:py-12 bg-white animate-fade-in">
          <div className="container mx-auto px-4 sm:px-6">
            <div className="text-center mb-8">
              <h3 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-2">
                GHR Series <span className="text-orange-600">Collection</span>
              </h3>
              <p className="text-gray-600 max-w-2xl mx-auto">
                Reflect elegance with our premium GHR finish tiles.
              </p>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-10">
              {ghrImages.map((img, index) => (
                <div
                  key={index}
                  className="group relative cursor-pointer overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 bg-white"
                  onClick={() => openModal(img.src, img.title, 'detail', img.roomScene)}
                >
                  <div className="aspect-[2/3] overflow-hidden relative">
                    <img
                      src={img.src}
                      alt={img.title}
                      className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-all duration-300"></div>
                  </div>

                  {/* Image Details */}
                  <div className="p-4 text-center">
                    <h4 className="text-gray-800 font-bold text-lg mb-1">{img.title}</h4>
                    <p className="text-gray-500 text-sm mb-1">Size: 600 x 1200 mm</p>
                    <span className="inline-block bg-orange-100 text-orange-800 text-xs px-2 py-1 rounded-full font-semibold">
                      GHR Finish
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* velvet */}
      {selectedFinish === 'VELVET' && selectedSize === "600 x 1200 mm" && (
        <section className="py-8 sm:py-12 bg-white animate-fade-in">
          <div className="container mx-auto px-4 sm:px-6">
            <div className="text-center mb-8">
              <h3 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-2">
                Velvet Series <span className="text-orange-600">Collection</span>
              </h3>
              <p className="text-gray-600 max-w-2xl mx-auto">
                Reflect elegance with our premium Velvet finish tiles.
              </p>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-10">
              {velvetImages.map((img, index) => (
                <div
                  key={index}
                  className="group relative cursor-pointer overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 bg-white"
                  onClick={() => openModal(img.src, img.title, 'detail', img.roomScene)}
                >
                  <div className="aspect-[2/3] overflow-hidden relative">
                    <img
                      src={img.src}
                      alt={img.title}
                      className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-all duration-300"></div>
                  </div>

                  {/* Image Details */}
                  <div className="p-4 text-center">
                    <h4 className="text-gray-800 font-bold text-lg mb-1">{img.title}</h4>
                    <p className="text-gray-500 text-sm mb-1">Size: 600 x 1200 mm</p>
                    <span className="inline-block bg-orange-100 text-orange-800 text-xs px-2 py-1 rounded-full font-semibold">
                      Velvet Finish
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* velvet */}
      {selectedFinish === 'ROKAR' && selectedSize === "600 x 1200 mm" && (
        <section className="py-8 sm:py-12 bg-white animate-fade-in">
          <div className="container mx-auto px-4 sm:px-6">
            <div className="text-center mb-8">
              <h3 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-2">
                Rokar Series <span className="text-orange-600">Collection</span>
              </h3>
              <p className="text-gray-600 max-w-2xl mx-auto">
                Reflect elegance with our premium Rokar finish tiles.
              </p>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-10">
              {rokarImages.map((img, index) => (
                <div
                  key={index}
                  className="group relative cursor-pointer overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 bg-white"
                  onClick={() => openModal(img.src, img.title, 'detail', img.roomScene)}
                >
                  <div className="aspect-[2/3] overflow-hidden relative">
                    <img
                      src={img.src}
                      alt={img.title}
                      className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-all duration-300"></div>
                  </div>

                  {/* Image Details */}
                  <div className="p-4 text-center">
                    <h4 className="text-gray-800 font-bold text-lg mb-1">{img.title}</h4>
                    <p className="text-gray-500 text-sm mb-1">Size: 600 x 1200 mm</p>
                    <span className="inline-block bg-orange-100 text-orange-800 text-xs px-2 py-1 rounded-full font-semibold">
                      Rokar Finish
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* inkyPinky */}
      {selectedFinish === 'INKY PINKY' && selectedSize === "600 x 1200 mm" && (
        <section className="py-8 sm:py-12 bg-white animate-fade-in">
          <div className="container mx-auto px-4 sm:px-6">
            <div className="text-center mb-8">
              <h3 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-2">
                Inky Pinky Series <span className="text-orange-600">Collection</span>
              </h3>
              <p className="text-gray-600 max-w-2xl mx-auto">
                Reflect elegance with our premium Rokar finish tiles.
              </p>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-10">
              {inkyPinkyImages.map((img, index) => (
                <div
                  key={index}
                  className="group relative cursor-pointer overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 bg-white"
                  onClick={() => openModal(img.src, img.title, 'detail', img.roomScene)}
                >
                  <div className="aspect-[2/3] overflow-hidden relative">
                    <img
                      src={img.src}
                      alt={img.title}
                      className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-all duration-300"></div>
                  </div>

                  {/* Image Details */}
                  <div className="p-4 text-center">
                    <h4 className="text-gray-800 font-bold text-lg mb-1">{img.title}</h4>
                    <p className="text-gray-500 text-sm mb-1">Size: 600 x 1200 mm</p>
                    <span className="inline-block bg-orange-100 text-orange-800 text-xs px-2 py-1 rounded-full font-semibold">
                      Inky Pinky Finish
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}



      {/* Technical Specifications */}
      <section className="py-8 sm:py-12 lg:py-16 bg-gray-50">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-3 sm:mb-4">
              Technical <span className="text-orange-600">Specifications</span>
            </h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8 max-w-2xl sm:max-w-4xl lg:max-w-6xl mx-auto">
            {[
              { icon: "💧", title: "Water Absorption", desc: "Less than 0.5% as per IS 15622" },
              { icon: "💪", title: "Breaking Strength", desc: "Minimum 1800N as per IS 15622" },
              { icon: "🌡️", title: "Thermal Shock", desc: "Resistant to temperature variations" },
            ].map((spec, index) => (
              <div key={index} className="bg-white p-4 sm:p-6 rounded-xl shadow-lg">
                <div className="text-orange-600 text-2xl sm:text-3xl md:text-4xl mb-3 sm:mb-4 text-center">{spec.icon}</div>
                <h3 className="text-base sm:text-lg md:text-xl font-bold text-gray-800 mb-2 text-center">{spec.title}</h3>
                <p className="text-sm sm:text-base text-gray-600 text-center">{spec.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-8 sm:py-12 lg:py-16 bg-gradient-to-r from-orange-600 to-orange-700">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-3 sm:mb-4">
            Transform Your Space Today
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-orange-100 mb-6 sm:mb-8 max-w-2xl sm:max-w-3xl mx-auto leading-relaxed">
            Contact our design experts to find the perfect Floor tiles for your project. Get personalized recommendations and professional installation support.
          </p>
        </div>
      </section>

      {/* Modal for Image Zoom */}
      {isModalOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50 p-2 sm:p-4"
          onClick={handleOutsideClick}
        >
          <div className={`relative w-full mx-auto outline-none ${selectedImage.viewMode === 'detail' ? 'max-w-7xl' : 'max-w-5xl'}`}>

            {selectedImage.viewMode === 'detail' ? (
              // Detailed Product Modal
              <div className="bg-white rounded-xl overflow-hidden shadow-2xl max-h-[90vh] overflow-y-auto">
                {/* Header */}
                <div className="bg-orange-600 p-4 sm:p-6 text-center relative">
                  <h2 className="text-white text-xl sm:text-3xl font-bold uppercase tracking-wider">{selectedImage.title}</h2>
                  <button
                    onClick={closeModal}
                    className="absolute top-1/2 -translate-y-1/2 right-4 sm:right-6 text-white hover:text-orange-200 transition-colors text-2xl font-bold"
                  >
                    ✕
                  </button>
                </div>

                <div className="flex flex-col lg:flex-row">
                  {/* Left: Room Scene */}
                  {!((selectedSize === '600 x 1200 mm' && selectedFinish !== 'GLOSSY') || ['Alabaster Grey', 'Alabaster Brown', 'ALORA BROWN', 'ALORA BEIGE', 'ALORA DECOR 1', 'ALORA DECOR 2', 'ELITE ONYX', 'EVOLIC NATURAL', 'EX-113 ARMANI GREY'].includes(selectedImage.title)) && (
                    <div className="lg:w-1/2 p-6 bg-gray-50 flex items-center justify-center">
                      <img
                        src={selectedImage.roomScene || selectedImage.src}
                        alt="Room Scene"
                        className="w-full h-full rounded-lg shadow-md object-cover max-h-[500px]"
                      />
                    </div>
                  )}

                  {/* Right: Faces & Info */}
                  <div className={`${((selectedSize === '600 x 1200 mm' && selectedFinish !== 'GLOSSY') || ['Alabaster Grey', 'Alabaster Brown', 'ALORA BROWN', 'ALORA BEIGE', 'ALORA DECOR 1', 'ALORA DECOR 2', 'ELITE ONYX', 'EVOLIC NATURAL', 'EX-113 ARMANI GREY'].includes(selectedImage.title)) ? 'w-full' : 'lg:w-1/2'} p-6 flex flex-col`}>
                    {/* Faces Grid */}
                    <div className="grid grid-cols-4 gap-3 mb-8">
                      {[1, 2, 3, 4].map((_, i) => (
                        <div key={i} className="aspect-[2/3] rounded-lg overflow-hidden border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
                          <img src={selectedImage.src} alt={`Face ${i + 1}`} className="w-full h-full object-cover" />
                        </div>
                      ))}
                    </div>

                    {/* Product Info */}
                    <div>
                      <p className="text-gray-600 text-lg mb-6 leading-relaxed">
                        Elegant polished texture with subtle veining for luxurious spaces.
                        Perfect for both residential and commercial applications.
                      </p>

                      <div className="flex flex-wrap gap-3 mb-6">
                        <span className="bg-orange-100 text-orange-800 px-4 py-2 rounded-full font-semibold">
                          Size: 600 x 600 mm
                        </span>
                        <span className="bg-orange-100 text-orange-800 px-4 py-2 rounded-full font-semibold">
                          Finish: {selectedFinish === 'CARVING' ? 'Carving' : 'Matt'}
                        </span>
                      </div>

                      <div className="space-y-2">
                        {['High Strength', 'Water Resistant', 'Stain Resistant', 'Easy Maintenance'].map((feat, i) => (
                          <div key={i} className="flex items-center text-gray-700">
                            <span className="text-orange-600 mr-2">✓</span>
                            {feat}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              // Simple Zoom Modal
              <div className="relative flex flex-col items-center justify-center">
                {isImageLoading && (
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-12 h-12 border-4 border-orange-600 border-t-transparent rounded-full animate-spin"></div>
                  </div>
                )}
                <img
                  src={selectedImage.src}
                  alt={`Zoomed view of ${selectedImage.title}`}
                  className="w-full h-auto max-h-[90vh] object-contain rounded-lg shadow-2xl bg-white"
                  onLoad={() => setIsImageLoading(false)}
                />
                <button
                  onClick={closeModal}
                  className="absolute top-2 right-2 bg-white text-black rounded-full p-2 hover:bg-gray-200 transition-all duration-300 text-xl font-bold shadow-lg"
                >
                  ✕
                </button>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Gvt;